import React, { useEffect } from "react";
import TileInfo from "@arcgis/core/layers/support/TileInfo";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Expand from "@arcgis/core/widgets/Expand";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import PortalBasemapsSource from "@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource";
import RootStore from "../stores/RootStore";
import MapComponent from "./mapComponent/src/components/WidgetComponent";
import nls from "./mapComponent/src/nls/strings";
import LayerStore from "@giscon/utils.layer-store";
import SelectionManager from "./mapComponent/src/SelectionManager";
import LayerManager from "./mapComponent/src/LayerManager";
import esriConfig from "@arcgis/core/config";

import * as watchUtils from "@arcgis/core/core/watchUtils";
import { observer } from "mobx-react";
import { runInAction } from "mobx";


function EsriMap({ className, children, style }) {
  const { map: mapConfig, constraints } = RootStore.config;

  useEffect(() => {
    esriConfig.portalUrl = "https://giscon-gi.maps.arcgis.com/";
    const newMap = new Map({
      basemap: {
        portalItem: {
          id: "d7e7aece4aa0467c857b29ecdd7f3749",
        },
      },
    });
    runInAction(() => { RootStore.mapStore.map = newMap; });
    if (constraints) {
      const newMapView = new MapView({
        map: newMap,
        container: "map-container",
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        extent: mapConfig.extent,
        constraints: { ...constraints, lods: TileInfo.create().lods },
      });
      runInAction(() => { RootStore.mapStore.mapView = newMapView; });
    } else {
      const newMapView = new MapView({
        map: newMap,
        container: "map-container",
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        extent: mapConfig.extent,
        constraints: { lods: TileInfo.create().lods },
      });
      runInAction(() => { RootStore.mapStore.mapView = newMapView; });
    }
    const view = RootStore.mapStore.mapView;
    if (window.views) {
      window.views.push(view);
    } else {
      window.views = [view];
    }

    view.when(() => {
      RootStore.mapStore.setMapReady(true);
      watchUtils.pausable(view, "popup", () => {
        const popup = view.popup;
        RootStore.mapStore.popup = popup;
        if (popup) {
          watchUtils.pausable(popup, "visible", () => {
            RootStore.mapStore.popupOpened = popup.visible;
          });
        }
        RootStore.mapStore.popupOpened = !!popup && popup.visible;
      });
    });

    const layerManager = new LayerManager({
      map: RootStore.mapStore.map,
      layers: [],
      view: RootStore.mapStore.mapView,
      selectionMode: SelectionManager.SELECTIONMODE_SAMELAYER,
      nls,
    });

    LayerStore.setLayerManager(layerManager);

    addMapWidgets(RootStore.mapStore.mapView);
  }, []);
  useEffect(() => {
    RootStore.mapStore.mapView.center = mapConfig.center;
  }, [mapConfig.center]);
  useEffect(() => {
    RootStore.mapStore.mapView.zoom = mapConfig.zoom;
  }, [mapConfig.zoom]);
  useEffect(() => {
    RootStore.mapStore.mapView.extent = mapConfig.extent;
  }, [mapConfig.extent]);
  return (
    <>
      <div className={className} style={style} id="map-container">
        {children}
      </div>
      {LayerStore.layerManager && LayerStore.selectionManager && (
        <MapComponent
          nls={nls}
          map={RootStore.mapStore.map}
          view={RootStore.mapStore.mapView}
          sendData={() => { }}
          urlParams={null}
          role={LayerStore.role}
          graphicSelectorOptions={null}
        />
      )}
    </>
  );
}

function addMapWidgets(view) {
  const portalBasemapSource = new PortalBasemapsSource({
    portal: "https://giscon-gi.maps.arcgis.com/",
    query: { tags: "KLIMABG" },
  });
  const basemapGallery = new BasemapGallery({
    view: view,
    source: portalBasemapSource,
  });
  RootStore.mapStore.basemapGallery = basemapGallery;
  const basemapGalleryExpand = new Expand({
    expandIconClass: "esri-icon-basemap",
    view: view,
    content: basemapGallery,
    expandTooltip: "Hintergrundkarten",
  });

  watchUtils.pausable(view.map, "basemap", () => {
    basemapGalleryExpand.collapse();
  });
  view.ui.add(basemapGalleryExpand, "top-left");
  view.ui.padding = { top: 70, right: 15, left: 15, bottom: 70 };
}

export default observer(EsriMap);
